import {setViewportTokens} from '@sail/helm';

setViewportTokens();
